module.exports = __webpack_public_path__ + "img/new-bell-icon.d7f0dcaa.svg";